// firebase.ts
import { initializeApp, type FirebaseApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyClxVI97zYIVNJ_scV7y_LKezgnmBQWOoI",
  authDomain: "algapia.firebaseapp.com",
  projectId: "algapia",
  storageBucket: "algapia.firebasestorage.app",
  messagingSenderId: "1088533120295",
  appId: "1:1088533120295:web:42f75a2462b83cb6461502",
};

export const app: FirebaseApp = initializeApp(firebaseConfig);
